import { FC, ReactNode } from 'react';
import { Tooltip } from '@/components/ui';

interface ChartCardProps {
    title: string;
    subtitle?: string;
    className?: string;
    description?: string;
    children: ReactNode;
}

export const InternalChartCard: FC<ChartCardProps> = ({ title, subtitle, className = '', description, children }) => (
    <div className={`bg-white border border-neutral-200/80 p-4 ${className}`}>
        <div className="mb-3">
            <div className="flex items-center gap-1.5">
                <h3 className="text-xs font-medium text-neutral-900">{title}</h3>
                {description && (
                    <Tooltip content={description}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-3.5 h-3.5 text-neutral-400 cursor-help">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                    </Tooltip>
                )}
            </div>
            {subtitle && <p className="text-[10px] text-neutral-500">{subtitle}</p>}
        </div>
        {children}
    </div>
);
